import { defineStore } from 'pinia'
import { createRestAPIClient } from 'masto'
import { Mutex } from 'async-mutex'

interface Statuses {
  [id: string]: any
}

var mutexes: { [id: string]: any } = {}
export const useStatusStore = defineStore('statuses', {
  state: () => {
    return {
      statuses: {} as Statuses,
    }
  },
  actions: {
    async fill(server: string, toot: string) {
      var cancel = false
      const masto = createRestAPIClient({ url: server })
      const instanceFetch = masto.v2.instance.fetch().catch(() => {
        console.error(['Failed to fetch instance!', 'server', server, 'toot', toot])
        cancel = true
      })
      const statusFetch = masto.v1.statuses
        .$select(toot)
        .fetch()
        .catch(() => {
          console.error(['Failed to fetch status!', 'server', server, 'toot', toot])
          cancel = true
        })
      const contextFetch = masto.v1.statuses
        .$select(toot)
        .context.fetch()
        .catch(() => {
          console.error(['Failed to fetch context!', 'server', server, 'toot', toot])
          cancel = true
        })
      const [instance, status, context]: any[] = await Promise.all([
        instanceFetch,
        statusFetch,
        contextFetch,
      ])
      if (cancel) return
      this.storeStatus(instance, status)
      context.descendants.forEach((child: any) => {
        this.storeStatus(instance, child)
      })
    },

    async lookup(server: string, toot: string) {
      if (!toot) return false
      if (!(toot in mutexes)) {
        mutexes[toot] = new Mutex()
      }
      await mutexes[toot].acquire()
      if (!(toot in this.statuses)) {
        await this.fill(server, toot)
      }
      mutexes[toot].release()
      return this.statuses[toot]
    },

    empty() {
      mutexes = {}
      this.statuses = {}
    },

    storeStatus(instance: any, status: any) {
      if (status.account.acct.indexOf('@') === -1) {
        status.account.acct += '@' + instance.domain
      }

      status.children = []
      this.statuses[status.id] = status
      const replyId = status.inReplyToId
      if (replyId && replyId in this.statuses) {
        if (!(status.id in this.statuses[replyId].children)) {
          this.statuses[replyId].children.push(status.id)
        }
      }
    },
  },
})
